import * as React from 'react'
import Avatar from 'components/Avatar'
import { FormGroup } from 'components/inputs'
import {
  CustomSelect,
  useCustomSelectStateFromInfiniteScrollProvider,
  MultiItemSelectedDefault,
} from 'components/inputs/CustomSelect'
import SearchResultItem from 'components/inputs/CustomSelect/SearchResultItem'
import { observer } from 'mobx-react'
import SupportingClientSelectorViewModel from '../../../../SupportingClientSelectorViewModel'

interface CompactSupportingClientSelectorProps {
  vm: SupportingClientSelectorViewModel
}

export default observer(function CompactSupportingClientSelector({
  vm,
}: CompactSupportingClientSelectorProps) {
  const selectProps = useCustomSelectStateFromInfiniteScrollProvider({
    scrollProvider: vm.scrollProvider,
    searchText: vm.searchText.value,
    onSearchTextChange: vm.triggerSearch,
  })

  return (
    <FormGroup>
      <CustomSelect
        {...selectProps}
        placeholder="Select supporting clients."
        itemToString={(v) => String(v?.displayName)}
        disabled={vm.disabled}
        focus$={vm.step.becomeActive$}
        onFocus={vm.step.onBecameActive}
        value={vm.selectedSupportingClient}
        onChange={vm.selectClientSupport}
        multi={true}
        data-test="compact-supporting-client-selector"
        renderItem={(itemProps) => (
          <MultiItemSelectedDefault
            visual={
              <Avatar
                size={24}
                subject={{
                  displayName: itemProps.item.displayName,
                  avatar: itemProps.item.avatar,
                }}
              />
            }
            {...itemProps}
          />
        )}
        renderSearchItem={({ item, itemToString, ...itemProps }) => (
          <SearchResultItem
            {...itemProps}
            visual={
              <Avatar
                size={24}
                subject={{
                  avatar: item.avatar,
                  displayName: item.displayName,
                }}
              />
            }
          >
            {item.displayName}
          </SearchResultItem>
        )}
      />
    </FormGroup>
  )
})
